import React from "react";
import style from "./CheckMark.module.css";

function CheckMark({
  checked,
  isBlue,
}: {
  checked: boolean;
  isBlue?: boolean;
}) {
  return (
    <div
      className={style.checkedContainer}
      style={{pointerEvents: "none"}}
    >
      {checked ? (
        <div
          className={`${style.checked} ${isBlue ? style.blueCheck : ""}`}
          style={{pointerEvents: "none"}}
        >
          {!isBlue ? (
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0108 0L3.93548 7.05L0.989247 4.11429L0 5.1L3.44086 8.52857L3.93548 9L4.43011 8.52857L12 0.985714L11.0108 0Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="20" height="20" rx="4" fill="#4609F0" />
              <path
                d="M5.3335 10.6666L8.00016 13.3333L14.6668 6.66663"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
        </div>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          
        >
          <path
            d="M5.33398 10.6666L8.00065 13.3333L14.6673 6.66663"
            stroke="#EDE6FE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className={style.check}
          />
          <rect
            x="0.5"
            y="0.5"
            width="19"
            height="19"
            rx="3.5"
            stroke="#BFC4C6"
          />
        </svg>
      )}
    </div>
  );
}

export default CheckMark;
